"use client";
import CreateSocialPerm from "@/features/mod-perms/components/create-social-perm";
import ModularPermissionsPanel from "@/features/mod-perms/components/main-perms";
import { useCheckForSocialAccount } from "@/features/mod-perms/hooks/useCheckForSocialAccount.hook";
import React from "react";

const ModPermsInterfaceSelector = () => {
  const { isSocialAccountBeingCreated, isLoaded } = useCheckForSocialAccount();

  if (isLoaded) {
    if (isSocialAccountBeingCreated) return <CreateSocialPerm />;
    else return <ModularPermissionsPanel />;
  }
};

export default ModPermsInterfaceSelector;
